import React from "react";
import { FaCheck, FaEdit, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { deleteQuestion } from "../../../redux/slice/questionSlice";
import DeleteButton from "../common/DeleteButton";

const QuestionItem = ({ index, question }) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/admin/edit-question/${question._id}`);
  };

  return (
    <div className="border-b-2 py-2 flex flex-col gap-2">
      <div className="flex justify-between px-4">
        <div className="flex flex-col items-start">
          <div>
            <span>
              {index + 1}.{question.questions}
            </span>
            {/* <span className="text-sm">[{question.marks}]</span> */}
          </div>
          <div className="flex sm:flex-row flex-col sm:gap-2 sm:pl-3 gap-1">
            <span className="py-1 rounded-[4px] px-2 text-[12px] bg-textSecondary/20">
              {question.marks} marks
            </span>
            <span className="py-1 rounded-[4px] px-2 text-[12px] bg-textSecondary/20">
              {question?.topicDetails?.topicName}
            </span>
            <span className="py-1 rounded-[4px] px-2 text-[12px] bg-textSecondary/20">
              {question?.subjectDetails?.subjectName}
            </span>
            <span className="py-1 rounded-[4px] px-2 text-[12px] bg-textSecondary/20">
              {question?.level}
            </span>
          </div>
        </div>
        <div className="flex gap-4 justify-center text-base">
          <FaEdit
            onClick={handleEdit}
            className="text-blue-700 cursor-pointer"
          />
          <DeleteButton
            data={question._id}
            toDispatch={deleteQuestion}
            type="Question"
          />
        </div>
      </div>
      <ul className="grid sm:grid-cols-4 sm:grid-rows-1 grid-cols-1 grid-rows-4 pl-14 sm:w-[90%]">
        {question.optionsOfAnswer.map((option) => (
          <li className="flex gap-2 items-center" key={option._id}>
            {option.isCorrect ? (
              <FaCheck className="text-sm text-green-600" />
            ) : (
              <FaTimes className="text-sm" />
            )}
            <span>{option.option}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuestionItem;
